import { memo } from "react";
import getBackgroundColor from "../../../../../../../helpers/getBackgroundColor";
import Icon from "../../../../../../Elements/Icon/Icon";
import Image from "../../../../../../Elements/Image/Image";
import { useContent } from "../../../../../../../contexts/contentContext/contentContext";

import styles from "./styles.module.scss";

interface OutboxIconI {
  isGroup: boolean;
  profilePhotoUrl: string;
  fullName: string;
  senderEmail: string;
  firstRecipient: string | undefined;
}

/**
 * Renders an icon or profile photo for the OutboxIcon component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {boolean} props.isGroup - Indicates whether the icon represents a group.
 * @param {string} props.profilePhotoUrl - The URL of the profile photo.
 * @param {string} props.fullName - The full name of the sender.
 * @param {string} props.senderEmail - The email address of the sender.
 * @param {string} props.firstRecipient - The email address of the first recipient.
 * @returns {JSX.Element} The rendered OutboxIcon component.
 */

const OutboxIcon = memo((props: OutboxIconI) => {
    const { isGroup, profilePhotoUrl, fullName, senderEmail, firstRecipient } =
        props;
    const { getTextByKey } = useContent();

    return (
        <>
            {isGroup ? (
                <div className={styles.groupIconWrapper}>
                    <Icon name="newInbox/group" large white showTitle={false} />
                </div>
            ) : profilePhotoUrl ? (
                <Image
                    src={profilePhotoUrl}
                    className={styles.profilePhoto}
                    alt={`${fullName} ${getTextByKey("profile-photo")}`}
                />
            ) : (
                <span
                    className={`${styles.profileLabel} ${styles.profilePhoto}`}
                    style={{
                        backgroundColor: getBackgroundColor(
                            fullName?.trim() || senderEmail?.trim() || firstRecipient
                        ) as string,
                    }}
                >
                    {(fullName?.trim() || senderEmail?.trim() || firstRecipient)?.slice(
                        0,
                        1
                    )}
                </span>
            )}
        </>
    );
});

export default OutboxIcon;
